(() => {
  if (customElements.get('sticky-images-and-text')) {
    return;
  }

  class StickyImagesAndText extends HTMLElement {
    constructor() {
      super();
      this.updateAnimation = this.updateAnimation.bind(this);
    }

    connectedCallback() {
      this.init();

      const handleIntersection = (entries) => {
        if (entries[0].isIntersecting) {
          this.attachEvents();
        } else {
          this.clearEvents();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        threshold: [0.33, 1],
      }).observe(this);
    }

    attachEvents() {
      window.addEventListener('scroll', this.updateAnimation);
    }

    clearEvents() {
      window.removeEventListener('scroll', this.updateAnimation);
    }

    init() {
      this.wrapperElement = this.querySelector('[data-wrapper-element]');
      this.stickyElement = this.querySelector('[data-sticky-element]');
      this.items = this.querySelectorAll('[data-item]');
      this.parallaxElement = this.querySelector('[data-parallax-element]');
    }

    updateAnimation() {
      const rect = this.wrapperElement.getBoundingClientRect();
      const wrapperHeight = this.wrapperElement.offsetHeight;
      const progress = (
        (Math.abs(rect.top) * 100) /
        (wrapperHeight - wrapperHeight * 0.33)
      ).toFixed(2);
      const itemsCount = this.items.length + 1;
      let targetItemIndex = Math.floor(progress / (100 / itemsCount));
      this.changeItem(targetItemIndex);
      this.changeImagePosition(progress);
    }

    changeItem(index) {
      const targetItem = this.items[index];

      if (!targetItem) {
        return;
      }

      this.items.forEach((item) =>
        item.classList.toggle('is-active', item === targetItem),
      );
    }

    changeImagePosition(progress) {
      this.parallaxElement.style.transform = `translateY(${-(progress * 2)}px)`;
    }
  }

  customElements.define('sticky-images-and-text', StickyImagesAndText);
})();
